// 工具模块
import config from '@/common/config'
import store from "@/store"

let noScroll = function (e) {
}
const tool = {
  noScroll(e) { e.preventDefault() },
  setCookie(key, value, time = 24) {
    key = tool.mergeKey(key)
    var date = new Date();
    date.setTime(date.getTime() + (time * 60 * 60 * 1000));
    var expires = "expires=" + date.toGMTString();
    document.cookie = key + "=" + value + "; " + expires;
  },
  getCookie(key) {
    key = tool.mergeKey(key);
    var name = key + "=";
    var params = document.cookie.split(';');
    for (var i = 0; i < params.length; i++) {
      var item = params[i].trim();
      if (item.indexOf(name) == 0) return item.substring(name.length, item.length);
    }
    return "";
  },
  isCanSignName(doctorInfo) {
    let keys = ["phone", "id_card_number", "id_card_front", "id_card_reverse", "bank_name", "bank_province", "bank_city", "bank_name_point", "bank_number"]
    let isHave = true;
    for (let key of keys) {
      if (!doctorInfo[key]) {
        isHave = false;
        break;
      }
    }
    // 是否审核通过
    let isAudit = doctorInfo.id_card_ocr_status == 1
    return isHave && isAudit
  },
  setLocalCookie(key, value, time = 24) {
    key = tool.mergeKey(key)
    let data = {
      val: value,
      time: Date.now() + time * 60 * 60 * 1000
    }
    tool.setStorage(`${key}_cookie`, data)

  },
  removeTouch() {
    // console.log(getEventListeners)
    // let list = window.getEventListeners(window)
    // list.forEach(e=>{
    //   document.body.removeEventListener("touchmove",(e)=>{e.preventDefault()},false)
    // })
    document.body.removeEventListener("touchmove", noScroll, { passive: false })
  },
  addTouch() {
    document.body.addEventListener('touchmove', noScroll, { passive: false })
  },
  isWindows() {
    return navigator.userAgent.includes("Windows")
  },
  isLogin() {
    return !!store.state.common.userInfo.name
  },
  isExecutor() {
    return !!store.state.common.executorInfo.name
  },
  getLocalCookie(key) {
    key = tool.mergeKey(key)
    let data = tool.getStorage(`${key}_cookie`) || { val: '', time: 0 }
    if (Date.now() < data.time) {
      return data.val;
    } else {
      return '';
    }
  },
  setStorage(key, val, storage = sessionStorage) {
    key = tool.mergeKey(key)
    // storage = sessionStorage || localStorage
    let data = {
      value: val
    }

    storage.setItem(key, JSON.stringify(data));
  },
  getStorage(key, storage = sessionStorage) {
    key = tool.mergeKey(key)
    // storage = sessionStorage || localStorage
    let data = storage.getItem(key);
    if (!data) return data;
    data = JSON.parse(data);
    return data.value
  },
  mergeKey(key) {
    return `${config.prefix}${key}`
  },
  getURL(url, data = {}) {
    let index = 0;
    for (let key in data) {
      let _symbol = index++ === 0 ? '?' : '&';
      url += `${_symbol}${key}=${data[key]}`
    }
    return url;
  },
  // 获取当前日期
  getDate(time, format = "yyyy-MM-dd") {
    let date = tool.getFormatTime(time),
      dateItem = {
        yyyy: date.getFullYear(),
        MM: tool.getTimeText(date.getMonth() + 1),
        dd: tool.getTimeText(date.getDate()),
        hh: tool.getTimeText(date.getHours()),
        mm: tool.getTimeText(date.getMinutes()),
        ss: tool.getTimeText(date.getSeconds())
      };
    let text = format;
    for (let key in dateItem) {
      text = text.replace(key, dateItem[key])
    }
    return text;
  },

  isWx() {
    let userAgent = navigator.userAgent.toLowerCase()
    return userAgent.includes('micromessenger')
  },
  isHaveMeetPermission() {

  },
  getSystemInfo() {
    let app = navigator.appVersion;
    let leftIndex = app.indexOf('(');
    let rightIndex = app.indexOf(')');
    let text = app.substring(leftIndex + 1, rightIndex);
    text = text.split(";");
    var Mobile_Iphone = text[0];
    var Mobile_Android = text[2];
    var res = /Android/;
    var result = res.test(Mobile_Android);
    let data = {
      device: Mobile_Iphone,
      version: '',
      width: window.screen.width,
      height: window.screen.height,
    }
    switch (Mobile_Iphone) {
      case 'Linux':
        let device = ''
        if (result) {
          device = text[4]
          data.version = text[2]
        } else {
          device = Mobile_Android
          data.version = text[1]
        }
        data.device = device.split('Build')[0]
        break;
      case 'iPhone': ;
      case 'iPad':
        data.device = text[0];
        let version = text[1].match(/OS\s([\d\_]+)\slike/g);
        version = version ? version[0] : '';
        data.version = version.split(/\s/)[1] ? `ios ${version.split(/\s/)[1]}` : ''
        break;
    }
    data.device = String(data.device).trim()
    data.version = String(data.version).trim().replace(/_/g, '.')
    return data;
  },
  saveVersion() {
    let version = tool.getStorage("version", localStorage) || ""
    if (version != config.version) {
      tool.setCookie("cookie", "")
      tool.setStorage("version", config.version, localStorage)
    }
  },
  getFormatDate(time) {
    let today = tool.getTime(tool.getDate())
    let currTime = tool.getTime(time)
    if (today < currTime) return tool.getDate(time, "hh:mm")
    if (today - 86400 * 1000 < currTime) return "昨天"
    if (today - 86400 * 1000 * 2 < currTime) return "前天"
    return tool.getDate(time)
  },
  download(file) {
    var a = document.createElement("a");
    a.target = "_blank";
    a.href = file;
    a.download = tool.getFileName(file);
    a.click();
  },
  getFileName(data) {
    let fileName = data.split("/").pop()
    return fileName
  },
  getTimeText(time) {
    time = String(time)
    return time[1] ? time : `0${time}`
  },
  // 获取上周日期
  getPrepWeek() {
    let date = new Date();
    let day = date.getDay();
    let curTime = date.getTime();
    let prepstartDay = curTime - (day + 7 - 1) * 24 * 60 * 60 * 1000;
    let prepEndDay = curTime - day * 24 * 60 * 60 * 1000;
    return {
      start_time: tool.getDate(prepstartDay),
      end_time: tool.getDate(prepEndDay)
    }
  },
  // 获取上个月日期
  getPrepMonth() {
    let date = new Date();
    let day = date.getDate();
    let curTime = date.getTime();
    let prepEndDay = curTime - day * 24 * 60 * 60 * 1000;
    let preDate = new Date(prepEndDay);
    let preTime = preDate.getTime();
    let preYear = preDate.getFullYear();
    let preMonth = preDate.getMonth() + 1;
    let preCountDay = new Date(preYear, preMonth, 0).getDate()
    let prepstartDay = preTime - (preCountDay - 1) * 24 * 60 * 60 * 1000;
    return {
      start_time: tool.getDate(prepstartDay),
      end_time: tool.getDate(prepEndDay)
    }
  },
  // 获取时间戳
  getFormatTime(time = "") {
    if (typeof time == "object" && time != null) return time;
    if (typeof time == "string") time = time.replace(/-/g, "/");
    if (time == "None") return new Date()
    return time ? new Date(time) : new Date();
  },
  getTime(time) {
    let value = 0;
    try {
      let dealWithTime = tool.getFormatTime(time)
      value = dealWithTime.getTime();
    } catch (err) { console.log(err) }
    return value
  },
  getTimePhase(time) {
    time = time / 1000;
    if (time < 60) return 0;
    if (time < 60 * 60) return 1;
    if (time < 60 * 60 * 24) return 2;
    if (time > 60 * 60 * 24) return 3;
  },
  getShowTime(time, format = "", showLen = 0) {
    let defaultFormat = format || ["秒", "分钟", "小时", "天"];
    let text = "";
    time = time || 0;
    let phase = showLen ?? tool.getTimePhase(time)
    time = Math.floor(time / 1000)
    let dataList = [
      time % 60,
      Math.floor(time / 60) % 60,
      Math.floor(time / (60 * 60)) % 60,
      Math.floor(time / (24 * 60 * 60)) % 24
    ]
    for (let len = defaultFormat.length, index = 0; index < len; index++) {
      if (dataList[index] <= 0 && index >= phase) break;
      let content = tool.getTimeText(dataList[index])
      text = `${content}${defaultFormat[index]}${text}`
    }
    return text;
  },
  sortChinese(data, key) {
    let dataList = []
    dataList = key ? data.sort((params1, params2) => {
      return params1[key].localeCompare(params2[key], "zh")
    })
      :
      dataList = data.sort((params1, params2) => {
        return params1.localeCompare(params2, "zh")
      })
    return dataList;
  },
  // type 0 为文本 1 为聊天
  getChatContent(content = "", type = 0, voice_id = "", voice_length = 0) {
    return {
      content: content,
      content_type: type,
      voice_id,
      voice_length
    }
  },
  isLocal() {
    const localURL = /^(192\.168\.\d{1,3}\.\d{1,3})|(localhost)|(127.0.0.1)|(172\.16\.\d{1,3}\.\d{1,3})$/;
    let hostname = window.location.hostname;
    return localURL.test(hostname)
  },
  isExecutor() {
    return store.state.common.salesInfo.user_type == 2
  },
  dealWithText(content, count = 0) {
    const enterSeparator = "xxxxxx";
    content = content.replace(/\n/g, enterSeparator)
    let contentList = content.split(/[\s]/g)
    let resultList = contentList.map(val => {
      let list = val.match(/([^\w]+)|(\w+)/g) || [];
      list = list.map(x => {
        return /\w+/g.test(x) ? x : x.split("")
      })
      return list.flat()
    })
    resultList = resultList.flat();
    let result = "";
    let fieldReg = /[\u4e00-\u9fa5a-zA-Z0-9]+/
    let wordsCount = 0;
    // count = count || resultList.length;
    // count = count < resultList.length ? count : resultList.length
    for (let index in resultList) {
      let val = resultList[index]
      let separator = /\w+/g.test(val) && !/^\d+$/g.test(val) && index !== 0 ? " " : ""
      result += `${separator}${val}`
      if (fieldReg.test(val)) wordsCount += 1;
      if (count != 0 && wordsCount >= count) break;
    }
    let enterReg = new RegExp(enterSeparator, "g")
    return {
      content: result.replace(enterReg, "\n"),
      count: wordsCount
    }
  },
  getCityConfig: async function () {
    return new Promise((resolve) => {
      import('@/common/citys.json').then(data => {
        resolve(data.default)
      })
    })
  },
  getBankConfig: async function () {
    return new Promise((resolve) => {
      import('@/common/bank.json').then(data => {
        resolve(data.default)
      })
    })
  },
  verifyDoctorInfo(doctor, isCheckLabor = false) {
    let commonFields = [
      "professional_cover", // 职称资料
      "name", // 姓名
      "hospital", // 医院
      "department",// 科室
      "phone",// 手机号
      "job_name", //
      "province", // 省份
      "city", // 城市
      // "job", //行政职务
      "resume_academic", //专家简历/学术任职
      "professional_cover", // 简历图片
    ]
    let laborFields = [
      "id_card_number", // 身份证照片
      "bank_province",// 银行卡信息
      "bank_city", // 银行卡城市
      "bank_name", // 银行
      "bank_name_point", // 支行
      "bank_number", // 银行卡号
      "bank_photo", // 银行卡照片
      "id_card_front",// 身份证人像面
      "id_card_reverse", // 身份证国徽面
    ]
    let checkFields = commonFields;
    if (isCheckLabor) {
      checkFields = checkFields.concat(laborFields)
    }
    // if(doctor.is_finish) return ""
    return checkFields.find(key => !doctor[key] || doctor[key] == "待定")
  },
  getRandomNum() {
    return 1e18 + Math.random() * 1e18;
  },
  secondsToHms(sec, format = "hh:mm:ss") {
    var hours;
    if (format.includes('hh')) {

      hours = Math.floor(sec / 3600);
    } else {
      hours = 0;

    }
    var minutes = Math.floor((sec - (hours * 3600)) / 60);
    var seconds = sec % 60;
    let dateItem = {
      hh: hours < 10 ? '0' + hours : hours,
      mm: minutes < 10 ? '0' + minutes : minutes,
      ss: seconds < 10 ? '0' + seconds : seconds
    };
    let text = format;
    for (let key in dateItem) {
      text = text.replace(key, dateItem[key])
    }
    return text;
  },
  HmsToSeconds(data) {
    let parts = data.split(':');
    let seconds = +parts[0] * 3600 + +parts[1] * 60 + +parts[2];
    return seconds;
  },
  compressImage: (file, convertToBase64 = false) => { // max=默认最大压缩到2M
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file); // 读出 base64
      reader.onloadend = ev => {
        let dataURL = ev.target.result;
        // 下面逻辑处理
        let file_mb = dataURL.length / (1024.0 * 1024);

        console.log(2, file_mb);

        let img = new Image();
        img.src = dataURL;
        if (file_mb <= 2) {
          return convertToBase64 ? resolve(ev.target.result) : resolve(file)
        }
        img.onload = () => {
          const canvas = document.createElement('canvas');
          if (!canvas) {
            return convertToBase64 ? resolve(ev.target.result) : resolve(file)
          }
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            return convertToBase64 ? resolve(ev.target.result) : resolve(file)
          }
          const width = 375
          const height = img.height * (375 / img.width);
          const ratio = 3;
          canvas.width = width * ratio;
          canvas.height = height * ratio;
          ctx.scale(ratio, ratio);
          ctx.fillStyle = '#fff';
          ctx.fillRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);
          const size = 0.4 //转换率，经测试0.4最好
          console.log(size, '-------')
          if (convertToBase64) {
            const base64 = canvas.toDataURL('image/jpeg', size)
            resolve(base64)
            return
          }
          canvas.toBlob(function (blob) {
            if (file?.name && blob) {
              blob.name = file.name
            }
            resolve(blob)
          }, 'image/jpeg', size)
        }
      }
    })
  },

}

export default tool;